import { Icon } from '../Icon/Icon';
import { IconChevronRight } from '@tabler/icons-react';

interface Item {
  link: string;
  text: string;
  icon?: string;
  selected: boolean;
}

interface Props {
  heading: string;
  ctaText?: string;
  ctaLink?: string;
  ctaIcon?: string;
  fileLink?: string;
  isExternalLink?: boolean;
  items: Item[];
}

export const ProductLinks: React.FC<Props> = ({
  heading,
  isExternalLink,
  ctaLink,
  ctaText,
  ctaIcon,
  fileLink,
  items,
}) => {
  const url = isExternalLink ? ctaLink : fileLink;

  return (
    <>
      <div className="flex flex-col items-center justify-between md:flex-row">
        <h2>{heading}</h2>

        {ctaText && ctaLink && (
          <a
            className={`border-dark-100 tc-secondary-button flex h-full w-full items-center justify-between rounded-[8px] md:w-auto ${ctaIcon ? 'py-0' : 'py-3'}`}
            href={url}
            download={!isExternalLink}
            target={isExternalLink ? '_blank' : undefined}
            rel={isExternalLink ? 'noopener noreferrer' : undefined}
            aria-label={ctaText}
          >
            <span className="pt-1">{ctaText}</span>
            {ctaIcon && <Icon name={ctaIcon} fillColour="transparent" strokeColour="dark" />}
          </a>
        )}
      </div>

      <ul className="list-none flex-wrap gap-4 p-0 sm:gap-6 md:flex">
        {items.map(({ link, text, icon, selected }, idx) => (
          <li key={'product_link_' + idx} className="mb-2 md:mb-0">
            <a
              className={`tc-secondary-button text-dark flex h-full items-center rounded-[8px] px-4 font-semibold transition-all ${icon ? 'py-1 pr-6' : 'py-3'} ${selected ? 'bg-primary text-neutral' : ''}`}
              href={link}
            >
              {icon && <Icon name={icon} fillColour="transparent" strokeColour="dark" size={24} />}
              <span className="pt-1 md:pt-0">{text}</span>
              <IconChevronRight className="mr-0 ml-auto md:hidden" />
            </a>
          </li>
        ))}
      </ul>
    </>
  );
};
